import axios from 'axios';
import { API_BASE } from '../../config';

// Wszystkie wywołania skanowania w jednym miejscu (G19 skan, G20 wydanie/zwrot).

const csrfHeaders = () => ({
  'X-CSRF-Token': (typeof window !== 'undefined' && window.localStorage.getItem('csrfToken')) || '',
});
const withSession = () => ({ withCredentials: true, headers: csrfHeaders() });
const enc = encodeURIComponent;

// ── Komputer ──────────────────────────────────────────────────────────────────────────

export async function createScanSession() {
  const r = await axios.post(`${API_BASE}/api/scan/sessions`, {}, withSession());
  return r.data; // { token, expiresAt }
}

export async function endScanSession(token) {
  try { await axios.delete(`${API_BASE}/api/scan/sessions/${enc(token)}`, withSession()); } catch (_) { /* sesja i tak wygaśnie */ }
}

export function scanEventsUrl(token) {
  return `${API_BASE}/api/scan/sessions/${enc(token)}/events`;
}

/** Sztuka TEJ organizacji o danym kodzie albo null (404). */
export async function lookupEquipmentByCode(code) {
  try {
    const r = await axios.get(`${API_BASE}/api/scan/lookup`, { withCredentials: true, params: { code } });
    return r.data;
  } catch (e) {
    if (e && e.response && e.response.status === 404) return null;
    throw e;
  }
}

// ── Telefon ───────────────────────────────────────────────────────────────────────────
// Bez sesji: token w adresie jest jedynym uwierzytelnieniem (patrz Login/backend/lib/scanSessions.js).

export async function phoneHello(token) {
  const r = await axios.get(`${API_BASE}/api/scan/sessions/${enc(token)}/phone`);
  return r.data; // { ok, expiresAt }
}

export async function phoneSendCode(token, code) {
  const r = await axios.post(`${API_BASE}/api/scan/sessions/${enc(token)}/codes`, { code });
  return r.data; // { delivered, expiresAt }
}

// ── Wydanie / zwrot ───────────────────────────────────────────────────────────────────

export async function fetchHandover(reservationId) {
  const r = await axios.get(`${API_BASE}/api/reservation-handover/${enc(reservationId)}`, { withCredentials: true });
  return r.data; // { cancelled, items, heldElsewhere }
}

export async function saveHandover(reservationId, { phase, equipmentIds, done = true }) {
  const r = await axios.post(
    `${API_BASE}/api/reservation-handover/${enc(reservationId)}`,
    { phase, equipmentIds, done },
    withSession()
  );
  return r.data;
}
